import React, { useState, useContext } from 'react'
import { Paper, InputBase, Typography } from "@material-ui/core";
import { makeStyles, fade } from "@material-ui/core/styles";

import DeleteIcon from '@material-ui/icons/Delete';
import CancelIcon from '@material-ui/icons/Cancel';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import StoredAPI from "../../utils/StoredAPI";
// Importar la fuente
import ItalianPlateNoBold from '../../assets/fonts/italian/ItalianPlateNoBold.otf';
import ItalianPlateNoRegular from '../../assets/fonts/italian/ItalianPlateNoRegular.otf';

const useStyles = makeStyles(theme => ({
    '@font-face': [
    {
        fontFamily: 'ItalianPlateNoBold',
        src: `url(${ItalianPlateNoBold}) format('opentype')`,
        fontWeight: 'bold',
        fontStyle: 'normal',
    },
    {
        fontFamily: 'ItalianPlateNoRegular',
        src: `url(${ItalianPlateNoRegular}) format('opentype')`,
        fontWeight: 'normal',
        fontStyle: 'normal',
    },
    ],
    customFont: {
        fontFamily: 'ItalianPlateNoBold, sans-serif',
        fontWeight: 'bold',
        fontSize: '17px',
        color: '#000',
        whiteSpace: 'pre'
    },
    customFontRegular: {
        fontFamily: 'ItalianPlateNoRegular, sans-serif',
        fontSize: '15px',
        color: 'grey',
        whiteSpace: 'pre'
    },
    card: {
        maxWidth: '100%',
        padding: theme.spacing(1, 1, 1, 1),
        margin: theme.spacing(1),
        cursor: 'pointer'
    },
    popupScreen: {
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: '0',
        right: '0',
        left: '0',
        backgroundColor: fade('#000', 0.86),
        cursor: 'not-allowed',
        zIndex: 9999999
    },
    popup: {
        width: '600px',
        height: '250px',
        borderRadius: '10px',
        backgroundColor: 'white',
        padding: theme.spacing(4),
        position: 'relative',
        cursor: 'auto',
        zIndex: '99999',
    },
    contenedorInfo:{
        display: 'flex',
        flexWrap: 'wrap',
        overflow: 'hidden',
        alignItems: 'flex-start', 
    },
    cancel: {
        cursor: 'pointer',
        position: 'absolute',
        right: '0',
        top: '0',
        margin: theme.spacing(4)
    },
    input: {
        maxWidth: '600px',
        height: 'fit-content',
        marginTop: theme.spacing(2),
        padding: theme.spacing(1),
        "&:focus": {
            backgroundColor: '#ddd'
        },
        fontSize: '14px'
    },
    editableTitle: {
        maxWidth: '600px',
        flexGrow: '1',
        color: 'grey',
        marginTop: theme.spacing(4),
        fontSize: '14px',
    },
    small: {
        fontSize: '12px',
        color: 'grey',
        marginTop: theme.spacing(1)
    }

}))

const Card = ({ card, cardIndex, listIndex,type }) => {


    const { updateCardContent, finalizarCard,cambiarStatus,reActivarCard } = useContext(StoredAPI)
    const classes = useStyles()

    const [popup, setPopup] = useState(false);
    const [open, setOpen] = useState(false);
    const [content, setContent] = useState(card.content)
    const values = Object.values(card);

    const valueStrings = values.map((value) => String(value)); // Convertir los valores a cadenas

    // Iterar sobre la matriz de cadenas y renderizar cada valor
    //const valueElements = valueStrings.map((value) => <div key={value}>{value}</div>);

    const valueElements =  <React.Fragment>
    {
        type != "listado" ? <>
        <span className={classes.customFontRegular}>{card.columna}</span>
        <span className={classes.customFont}> {"{C}"} </span>
    </> : null
    }
   
    <span className={classes.customFontRegular}>{card.cliente}</span>
    <span className={classes.customFont}> {"{D}"} </span>
    <span className={classes.customFontRegular}>{card.destino}</span>
    <span className={classes.customFont}> {"{O}"} </span>
    <span className={classes.customFontRegular}>{card.numOF}</span>
    <span className={classes.customFont}> {"{F}"} </span>
    <span className={classes.customFontRegular}>{card.dataEntrega}</span>
    {
        type == "listado" ? <div>{"\n"}</div> : null
    }
    
    <span className={classes.customFont}> {"{Q}"} </span>
    <span className={classes.customFontRegular}>{card.qualitat}</span>
    <span className={classes.customFont}> {"{G}"} </span>
    <span className={classes.customFontRegular}>{card.gramatge}</span>
    <span className={classes.customFont}> {"{B}"} </span>
    <span className={classes.customFontRegular}>{card.ampleBobina}</span>
    {
        type == "listado" ? <div>{"\n"}</div> : null
    }
    <span className={classes.customFont}> {"{A}"} </span>
    <span className={classes.customFontRegular}>{card.ampleTall}</span>
    <span className={classes.customFont}> {"{L}"} </span>
    <span className={classes.customFontRegular}>{card.llargTall}</span>
    <span className={classes.customFont}> {"{F}"} </span>
    <span className={classes.customFontRegular}>{card.numFulls}</span>
    <span className={classes.customFont}> {"{K}"} </span>
    <span className={classes.customFontRegular}>{card.kilos}</span>
    <span className={classes.customFont}> {"{O}"} </span>
    <span className={classes.customFontRegular}>{card.observacions}</span>
    

    </React.Fragment>
    

    const handleOnDone = () => {
        if(content.length <= 1060){
            updateCardContent(content, listIndex, cardIndex)
            setOpen(!open);
        }
        else{
            alert("Character limit exceeded. Try to add note within 1060 characters.")
        }
    }

    const handleArchivar = () =>{
        finalizarCard(listIndex, cardIndex);
        setPopup(false)
    }

    const handleReActivar = () =>{
        reActivarCard(listIndex, cardIndex);
        setPopup(false)
    }


    const handleEntrar = () =>{
        cambiarStatus(listIndex, cardIndex,"entrar");
        setPopup(false)
    }

    const handleSalir = () =>{
        cambiarStatus(listIndex, cardIndex,"salir");
        setPopup(false)
    }
    return (

        <div>

            { popup && (
                <div className={classes.popupScreen}>
                    <div className={classes.popup}>
                        <CancelIcon className={classes.cancel} onClick={() => setPopup(false)} />
                        <h1>{card.cliente}</h1>
                        <div className={classes.contenedorInfo}>
                            {valueElements}
                        </div>
                        {open ? (
                            <div>
                                <InputBase value={content}
                                    autoFocus
                                    inputProps={{
                                        className: classes.input
                                    }}
                                    fullWidth
                                    onChange={(e) => setContent(e.target.value)}
                                />
                                <button className="done-btn" onClick={handleOnDone}>Done</button>
                            </div>
                        ) : (
                                <div className={classes.editableTitleContainer}>

                                    <Typography className={classes.editableTitle}
                                        onClick={() => setOpen(!open)}>{content}</Typography>

                                </div>
                            )}

                        <div class="button-container">
                            {
                                card.finalizado != true
                                ?
                                <>
                                    {
                                        card.status != "entrar" ?
                                        <div className="add-btn" onClick={handleEntrar}>
                                            Entrar en Maquina
                                        </div> : null
                                    }
                                    
                                    <div className="add-btn" onClick={handleSalir}>
                                        Sacar de Maquina 
                                    </div>
                                    

                                    <div className="delete-btn" onClick={handleArchivar}>
                                    Finalización Orden
                                    </div>
                                </>
                                : 
                                <div className="delete-btn" onClick={handleReActivar}>
                                    Devolverá a máquina
                                </div>
                            }
                           
                            
                        </div>
                        
                        
                    </div>
                </div>

            )}

            <Draggable draggableId={card.id} index={cardIndex}>
                {(provided) => (
                    <div
                        ref={provided.innerRef} {...provided.dragHandleProps}
                        {...provided.draggableProps}
                        onClick={() => setPopup(true)}
                    >
                        <Paper className={classes.card} style={{backgroundColor: card.status === "entrar" ? "#d8fcd8" : "#FFFFFF"}}>
                            <h4 style={{ color: '#696969'}}>{valueElements}</h4>
                           
                            <p className={classes.small}>{content}</p>
                        </Paper>
                        
                    </div>
                )}

            </Draggable>
        </div>
    )
}

export default Card
